const actions = {
  resolveError(context, data) {
    return new Promise((_resolve, reject) => {
      context.commit('SET_ERROR_CODE', data?.err?.response?.data?.error?.code);
      if (data.err?.response?.status === 401) {
        context.commit('CLEAR_SESSION');
      } else if (data.err?.response?.data) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data?.err?.response?.data?.error?.message);
        }
        reject(new Error(data?.err?.response?.data?.error?.message));
      } else if (data.errBlob?.error) {
        if (!data?.hideError) {
          context.commit('SET_ERROR_MESSAGE', data?.errBlob?.error?.message);
        }
        reject(new Error(data?.errBlob?.error?.message));
      } else {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', 'Apologies! Currently we are experiencing heavy load. Please try again in sometime!');
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
  resolveErrorDigiLockerKarzaOtp(context, data) {
    return new Promise((_resolve, reject) => {
      if (data.err?.response?.status === 401) {
        context.commit('CLEAR_SESSION');
      } else if (data.err?.response.data.error.code === 'EPL-10000') {
        reject(new Error(data.err.response.data.error.code));
      } else if (data.err?.response?.data) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data?.err?.response?.data?.error?.message);
        }
        reject(new Error(data?.err?.response?.data?.error?.message));
      } else if (data.errBlob?.error) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data?.errBlob?.error?.message);
        }
        reject(new Error(data?.errBlob?.error?.message));
      } else {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', 'Apologies! Currently we are experiencing heavy load. Please try again in sometime!');
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
  resolveErrorDisablePopUp(context, data) {
    return new Promise((_resolve, reject) => {
      if (data.err?.response?.status === 401) {
        context.commit('CLEAR_SESSION');
      } else if (data.err?.response?.data) {
        if (!data.hideError) {
          reject(new Error(data?.err?.response?.data?.error?.message));
        }
      } else if (data?.errBlob?.error) {
        if (!data?.hideError) {
          reject(new Error(data?.errBlob?.error?.message));
        }
      } else {
        if (!data.hideError) {
          reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
  resolveErrorCodeForEmanDateKyc(context, data) {
    return new Promise((_resolve, reject) => {
      if (data.err?.response?.status === 401) {
        context.commit('CLEAR_SESSION');
      } else if (data?.err?.response?.data) {
        if (!data?.hideError) {
          if (data?.err?.response?.data?.error?.code === 'EPL-10000') {
            reject(new Error(data?.err?.response?.data?.error?.code));
          } else {
            reject(new Error(data?.err?.response?.data?.error?.message));
          }
        }
      } else if (data?.errBlob?.error) {
        if (!data?.hideError) {
          reject(new Error(data?.errBlob?.error?.message));
        }
      } else {
        if (!data.hideError) {
          reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
};
export default actions;
